module.exports = __webpack_public_path__ + "images/oliver.a7cc760059.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/oliver.jpg
// module id = wWeI
// module chunks = 2